import { MicrosoftOutlookLogo } from '@phosphor-icons/react';

export default MicrosoftOutlookLogo;
